import { createAction, createApiAction } from 'store';
import * as types from 'modules/admin-panel/pages/settings/ActionTypes';
import {
	INotificationPayload,
	IPostTemplateParams,
	IReplaceTemplateParams,
	ISurveyRoundPayload,
} from 'modules/admin-panel/pages/settings/models';

export const getUserDetails = createApiAction(types.GET_USER_DETAILS);
export const updateUserDetails = createApiAction(types.UPDATE_USER_DETAILS);

export const deleteUserByThemselves = createApiAction(
	types.DELETE_USER_BY_THEMSELVES,
);

export const createUserPassword = createApiAction(types.CREATE_USER_PASSWORD);
export const resetPasswordByAdmin = createApiAction(
	types.RESET_PASSWORD_BY_ADMIN,
);
export const deleteUserByAdmin = createApiAction(types.DELETE_USER_BY_ADMIN);

export const getSurveySent = createApiAction(types.GET_SURVEY_SENT);

export const postUserPhoto = createApiAction(types.POST_USER_PHOTO);

export const getLastCreatedSurveyList = createApiAction(
	types.GET_LAST_CREATED_SURVEY_LIST,
);

export const resetResult = createAction(types.RESET_RESULT);
export const resetError = createAction(types.RESET_ERROR);

// Survey Tracking
export const getTrackingSurveyList = createApiAction(
	types.GET_TRACKING_SURVEY_LIST,
);

export const getAllTrackingSurveyList = createApiAction(
	types.GET_ALL_TRACKING_SURVEY_LIST,
);

export const getStopSurvey = createApiAction<{ surveyId: string }>(
	types.GET_STOP_SURVEY,
);

export const deleteSurvey = createApiAction<{ surveyId: string }>(
	types.DELETE_SURVEY,
);

export const getStopSurveyRound = createApiAction<{ surveyRoundId: string }>(
	types.GET_STOP_SURVEY_ROUND,
);

export const sendNotifications = createApiAction<INotificationPayload>(
	types.GET_SEND_NOTIFICATIONS,
);
export const resetNotificationError = createAction(
	types.RESET_NOTIFICATION_ERROR,
);

export const getSurveyRound = createApiAction<{ id: string }>(
	types.GET_SURVEY_ROUND,
);
export const resetEditableRound = createAction(types.RESET_EDITABLE_ROUND);
export const editSurveyRound = createApiAction<ISurveyRoundPayload>(
	types.EDIT_SURVEY_ROUND,
);
export const resetIsRoundEdited = createAction(types.RESET_IS_ROUND_EDITED);

export const resetRoundEditingError = createAction(
	types.RESET_ROUND_EDITING_ERROR,
);

/* EMAIL TEMPLATES */
export const getEmailTemplatesData = createApiAction<{
	surveyId: string;
	clientId: string;
}>(types.GET_EMAIL_TEMPLATES_DATA);
export const getClientInvitationTemplate = createApiAction<{
	surveyId: string;
}>(types.GET_CLIENT_INVITATION_TEMPLATE);
export const getClientReminderTemplate = createApiAction<{ surveyId: string }>(
	types.GET_CLIENT_REMINDER_TEMPLATE,
);
export const postEmailTemplate = createApiAction<IPostTemplateParams>(
	types.POST_EMAIL_TEMPLATE,
);
export const replaceEmailTemplate = createApiAction<IReplaceTemplateParams>(
	types.REPLACE_EMAIL_TEMPLATE,
);
export const resetEmailEditingStatuses = createAction(
	types.RESET_EMAIL_EDITING_STATUSES,
);
